import $ from "jquery"
import Vue from "vue"
import MicroModal from "micromodal"
import vueNumeralFilterInstaller from "vue-numeral-filter"
import UnitsTable from "../../vue-components/UnitsTable.vue"

require("readmore-js")

const estate = () => {
	// Units
	if (document.querySelector("#units")) {
		Vue.use(vueNumeralFilterInstaller, {
			locale: "nl-nl",
		})
		new Vue({
			el: "#units",
			render: (h) => h(UnitsTable),
		})
	}

	if (document.querySelector(".js-estate")) {
		const youtubeParser = (url) => {
			// Ondersteunt watch, embed, shorts, en youtu.be links
			const regExp =
				/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^\s&?\/]+)/
			const match = url.match(regExp)
			return match && match[1].length === 11 ? match[1] : false
		}

		const $iframe = $("#estateVideo").find("iframe")

		if ($iframe.length) {
			const videoUrl = $iframe.attr("data-video")

			if (typeof videoUrl === "string" && videoUrl.trim() !== "") {
				const videoId = youtubeParser(videoUrl)

				if (videoId && typeof videoId === "string" && videoId.length === 11) {
					const videoSrc = `${videoId}?iv_load_policy=3&listType=user_uploads&controls=1&fs=0&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`
					$iframe.attr("src", `https://www.youtube.com/embed/${videoSrc}`)

					if (videoUrl.includes("shorts")) {
						$iframe.addClass("is-shorts")

						if ($iframe.parent().length) {
							$iframe.parent().addClass("has-shorts-video")
						}
					}
				}
			}
		}
	}

	// Description
	if (document.querySelector(".js-description")) {
		let txtReadmore = "Lire plus"
		let txtReadless = "Lire moins"
		if (window.descriptionData.lang === "nl") {
			txtReadmore = "Lees meer"
			txtReadless = "Lees minder"
		}
		$(".js-description").readmore({
			speed: 75,
			collapsedHeight: 110,
			moreLink: `<a href="#" class="mt-6 btn-link is-line">${txtReadmore}</a>`,
			lessLink: `<a href="#" class="mt-6 btn-link is-line">${txtReadless}</a>`,
		})
	}

	// Modal
	if (document.querySelector(".modal")) {
		MicroModal.init({
			disableScroll: true,
			awaitCloseAnimation: true,
		})
	}

	// Investment
	if (document.querySelector("#modal-investment")) {
		$(".js-open-investment").on("click", (e) => {
			e.preventDefault()
			MicroModal.show("modal-investment")
		})

		$(".js-close-investment").on("click", (e) => {
			e.preventDefault()
			MicroModal.close("modal-investment")
		})
	}

	// Rent
	if (document.querySelector("#modal-rent")) {
		$(".js-open-rent").on("click", (e) => {
			e.preventDefault()
			MicroModal.show("modal-rent")
		})

		$(".js-close-rent").on("click", (e) => {
			e.preventDefault()
			MicroModal.close("modal-rent")
		})
	}
}

export default estate
